import React from "react";

type PreviousName = {
  name: string;
  from?: string | null;
  until: string; // required
  type:string
};

export type ProfileForm = {
  fullName?: string | null;
  nicknames?: string | null;
  pronoun?: string | null;
  hadOtherLegalNames?: "yes" | "no" | null;
  previousNames?: PreviousName[] | null;
  dominantHand?: string | null;
  placeOfBirth?: string | null;
  currentResidence?: string | null;
  spiritualOrientation?: string | null;
  birth?: {
    date?: string | null; // yyyy-mm-dd
    time?: string | null; // HH:mm
    place?: string | null;
  } | null;
  id?: string,
  relation?:string
};

// Format DOB → "September 1, 1996, 6:01 PM"
function formatDob(
  dateStr?: string | null,
  timeStr?: string | null
): string | null {
  if (!dateStr || !dateStr.trim()) return null;

  const parts = dateStr.trim().split("-");
  if (parts.length !== 3) return dateStr;

  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  if (
    Number.isNaN(year) ||
    Number.isNaN(month) ||
    Number.isNaN(day)
  ) {
    return dateStr;
  }

  let hh = 0;
  let mm = 0;

  if (timeStr && timeStr.trim()) {
    const timeParts = timeStr.split(":");
    hh = parseInt(timeParts[0], 10) || 0;
    mm = parseInt(timeParts[1], 10) || 0;
  }

  const dateObj = new Date(year, month - 1, day, hh, mm);

  const dayStr = String(dateObj.getDate()).padStart(2, "0");

  const monthStr = dateObj
    .toLocaleString("en-US", { month: "short" })
    .replace(".", ""); // safety for some locales

  const yearStr = dateObj.getFullYear();

  let formatted = `${dayStr} ${monthStr} ${yearStr}`;

  if (timeStr && timeStr.trim()) {
    const hourStr = String(dateObj.getHours()).padStart(2, "0");
    const minuteStr = String(dateObj.getMinutes()).padStart(2, "0");
    formatted += `, ${hourStr}:${minuteStr}`;
  }

  return formatted;
}



export default function ProfileFields({ form }: { form: ProfileForm | undefined }) {
  const {
    fullName,
    nicknames,
    pronoun,
    hadOtherLegalNames,
    previousNames,
    dominantHand,
    placeOfBirth,
    currentResidence,
    spiritualOrientation,
    birth,
    relation
  } = form || {};

  console.log("whole data", form)
  const prevNamesSafe = Array.isArray(previousNames) ? previousNames : [];
  const prevNamesFiltered = prevNamesSafe.filter((p) => p?.name?.trim());

  const dobFormatted = formatDob(birth?.date ?? null, birth?.time ?? null);
  console.log("birth", birth)

  const Row: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
    <div className="py-3">
      <div className="flex flex-row items-start justify-between gap-4">
        <dt className="text-sm text-dark-text font-medium flex-none">
          {label}
        </dt>
  
        <dd className="text-sm text-white text-right flex-1 break-words">
          {value}
        </dd>
      </div>
    </div>
  );
  

  return (
    <dl className="mt-6  text-sm">
      {fullName && <Row label="Full name" value={fullName} />}
      {Array.isArray(nicknames) && nicknames.length > 0 && (
  <Row label="Nicknames" value={nicknames.join(", ")} />
)}
      {pronoun && <Row label="Pronoun" value={pronoun} />}

      {hadOtherLegalNames === "yes" && prevNamesFiltered.length > 0 && (
  <div className="py-3">
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between sm:gap-6">
      <dt className="text-sm text-dark-text font-medium flex-none sm:w-48">
        Prior legal name(s)
      </dt>

      <dd className="mt-1 text-sm sm:mt-0 flex-1 sm:text-right">
        <ul className="space-y-2 text-white">
          {prevNamesFiltered.map((p, i) => {
            const from = formatDob(p.from);
            const until = formatDob(p.until);

            return (
              <li key={`${p.name}-${i}`} className="break-words">
                {p.name}

                {from && until ? (
                  <span> — from {from} until {until}</span>
                ) : from ? (
                  <span> — from {from}</span>
                ) : until ? (
                  <span> — until {until}</span>
                ) : null}
              </li>
            );
          })}
        </ul>
      </dd>
    </div>
  </div>
)}


      {dobFormatted && <Row label="Date & time of birth" value={dobFormatted} />}
      {dominantHand && <Row label="Dominant hand" value={<span className="capitalize">{dominantHand}</span>} />}
      {placeOfBirth && <Row label="Place of birth" value={placeOfBirth} />}
      {currentResidence && <Row label="Current residence" value={currentResidence} />}
      {spiritualOrientation && <Row label="Spiritual orientation" value={spiritualOrientation} />}
      {relation && <Row label="Relationship" value={relation} />}
    </dl>
  );
}
